export enum ExperimentType {
  CUSTOMER_JOURNEY = 'CUSTOMER_JOURNEY',
  PLAN_ENTITLEMENTS = 'PLAN_ENTITLEMENTS',
}
